import * as React from 'react';

const KebabMenu = (props) => (
  <svg
    width={19}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)" fill="#858D9D">
      <path d="M9.89 5.178a2.403 2.403 0 0 1-2.4-2.409A2.403 2.403 0 0 1 9.89.362a2.403 2.403 0 0 1 2.397 2.407A2.404 2.404 0 0 1 9.89 5.178ZM9.89 11.77a2.403 2.403 0 0 1-2.4-2.408 2.404 2.404 0 0 1 2.4-2.409 2.405 2.405 0 0 1 2.398 2.409A2.404 2.404 0 0 1 9.89 11.77ZM9.89 18.362a2.403 2.403 0 0 1-2.4-2.409 2.402 2.402 0 0 1 2.4-2.408 2.403 2.403 0 0 1 2.397 2.408 2.404 2.404 0 0 1-2.397 2.409Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.889 .362)" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default KebabMenu;
